"use strict";

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _flummox = require("flummox");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuActions = (function (_Actions) {
    _inherits(MenuActions, _Actions);

    function MenuActions() {
        _classCallCheck(this, MenuActions);

        return _possibleConstructorReturn(this, Object.getPrototypeOf(MenuActions).apply(this, arguments));
    }

    _createClass(MenuActions, [{
        key: "setParams",
        value: function setParams(params) {
            return params;
        }
    }]);

    return MenuActions;
})(_flummox.Actions);

exports.default = MenuActions;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-contextmenu/modules/flux/actions.js
 ** module id = 842
 ** module chunks = 0
 **/